import { round } from '@gamiphy/utils/number';
import { Discount } from './types';

export const getGemsValue = (gems: number, discount?: Discount): number => {
  if (discount) {
    return Number(round(discount.value * gems, 2));
  }
  return 0;
};
